/**
 * mapping of poles
 */
export const poles = [
    {
        language: 'connection',
        opposite: 'boundaries'
    },
    {
        language: 'boundaries',
        opposite: 'connection'
    },
    {
        language: 'empowerment',
        opposite: 'mentoring'
    },
    {
        language: 'mentoring',
        opposite: 'empowerment'
    },
    {
        language: 'proximity',
        opposite: 'autonomy'
    },
    {
        language: 'autonomy',
        opposite: 'proximity'
    },
    {
        language: 'feedback',
        opposite: 'recognition'
    },
    {
        language: 'recognition',
        opposite: 'feedback'
    },
    {
        language: 'performance',
        opposite: 'purpose'
    },
    {
        language: 'purpose',
        opposite: 'performance'
    }
];
/**
 * statements
 */
export const statements = [
    {
        statement: 'Builds a personal relationship with me as well as a working one',
        primary: poles[0].language,
        secondary: poles[0].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: 'Sets aside regular time to mentor and coach me',
        primary: poles[3].language,
        secondary: poles[3].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Is present often enough (virtually or physically) to see the work I do`,
        primary: poles[4].language,
        secondary: poles[4].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Tells me regularly and specifically what she/he appreciates about my contribution`,
        primary: poles[7].language,
        secondary: poles[7].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Focuses on results instead of trying to make work meaningful`,
        primary: poles[8].language,
        secondary: poles[8].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Understands I'm here to do a job, friendship is nice, not needed`,
        primary: poles[1].language,
        secondary: poles[1].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Trusts that I know what I'm doing and don't need a lot of support`,
        primary: poles[2].language,
        secondary: poles[2].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Is present (virtually or physically) as often as I am			`,
        primary: poles[4].language,
        secondary: poles[4].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Focuses feedback on what I can improve, rather than what I did well`,
        primary: poles[6].language,
        secondary: poles[6].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Reminds me how my day-to-day work supports to our larger mission in the world`,
        primary: poles[9].language,
        secondary: poles[9].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Engages in conversations about our hobbies and interests outside of work`,
        primary: poles[0].language,
        secondary: poles[0].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },

    {
        statement: `Is most focused on my professional development`,
        primary: poles[3].language,
        secondary: poles[3].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Let's me get my work done without a lot of discussion or meetings about it.`,
        primary: poles[5].language,
        secondary: poles[5].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Articulates an inspiring vision for how our work can make a positive impact for people`,
        primary: poles[9].language,
        secondary: poles[9].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Doesn't dance around my feelings and just tells me where I can improve`,
        primary: poles[6].language,
        secondary: poles[6].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Respects my personal life as personal, we don't need to get into it at work`,
        primary: poles[1].language,
        secondary: poles[1].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Tells me what he/she needs, but doesn't try to tell me how`,
        primary: poles[2].language,
        secondary: poles[2].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Gives me clear visibilty into his/her work, I like to know what my boss is doing.`,
        primary: poles[4].language,
        secondary: poles[4].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Frequently acknowledges my hard work and contribution in public or private`,
        primary: poles[7].language,
        secondary: poles[7].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Isn't overly focused on fuzzy things like "higher purpose," when we have work to do`,
        primary: poles[8].language,
        secondary: poles[8].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Doesn't waste a lot of time chatting about things outside of work`,
        primary: poles[1].language,
        secondary: poles[1].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Frequently looks for teachable moments to mentor me`,
        primary: poles[3].language,
        secondary: poles[3].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Gives me a lot of space to work alone`,
        primary: poles[5].language,
        secondary: poles[5].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Easily and often expresses gratitude for excellent work I've done`,
        primary: poles[7].language,
        secondary: poles[7].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Focuses on driving performance not inspiring high-minded organizational vision`,
        primary: poles[8].language,
        secondary: poles[8].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Shows interest in me as a person not just a cog in a machine`,
        primary: poles[0].language,
        secondary: poles[0].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Gives me the authority to do my job with little to no guidance`,
        primary: poles[2].language,
        secondary: poles[2].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Is only engaged in my work if it's absolutely necessary`,
        primary: poles[5].language,
        secondary: poles[5].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Gives me critical and constructive feedback, more than accolades`,
        primary: poles[6].language,
        secondary: poles[6].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Articulates a clear higher purpose that goes beyond making money`,
        primary: poles[9].language,
        secondary: poles[9].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },

];